/**
 * Service: userPreferencesApi
 */
angular.module('acme.common.service.userPreferencesApi', [
  'acme.common.factory.apiVersion'
])
.service('UserPreferencesApiService', ['$http', 'ApiVersionFactory', function($http, ApiVersionFactory) {

    return {

      init: function(endpoint) {
        var av = new ApiVersionFactory();
        this.service = av.init({ url: endpoint + '/user/preferences/b2b', version: 'v2' });
        return this;
      },

      get: function(id) {

        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      },

      create: function(id, props, userId) {
        var data = {
          preferences: props.preferences || [],
          viewId: id,
          userId: userId,
          app: 'b2b'
        };
        return $http({
          method: 'post',
          url: this.service + '/' + id,
          data: data
        });
      },

      update: function (id, props, userId) {
        var data = {
          preferences:  props.preferences || [],
          viewId: id,
          userId: userId,
          app: 'b2b'
        };
        return $http({
          method: 'put',
          url: this.service + '/' + id,
          data: data
        });
      }

    };

}]);
